module.exports = __webpack_public_path__ + "static/img/45.a580ea7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/15/45.jpg
// module id = 706
// module chunks = 0